import stylesModule from "./Loading.module.sass";

const Loading = props => {
  return (
    <div className={stylesModule.loading}>
      <h2 className={stylesModule.text}>
        ¡Hola! Estamos preparando algo
        <span className={stylesModule.keyword}> realmente especial</span> para
        ti. Por favor, tómate un momento y
        <span className={stylesModule.keyword}> relájate</span>...
      </h2>
    </div>
  );
};

export default Loading;
